import React from 'react';
/*
To import child routes, insert the following code:
import { <childComponent>Routes } from './components/<child-folder>';
*/

import { Route } from '@plasma/ui.application.router';

const CurrentRfqStatus = React.lazy(() => import('.'));

export const currentRfqStatusRoutes = [
  new Route({
    path: 'current-rfq-status',
    element: CurrentRfqStatus,
    children: [],
  }),
];
